import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';
import { LogManagerConsole } from 'Core/logManager';

export const tagAdapter = createEntityAdapter({
    selectId: (tag) => String(tag.id)
});

const tagSlice = createSlice({
    name: 'realtime_tag',
    initialState: tagAdapter.getInitialState(),
    reducers: {
        upsertManyWithRules: (state, action) => {
            const items = action.payload;

            LogManagerConsole("RT_DEBUG", "[TagSlice] upsertManyWithRules dispatched incoming size:", items ? items.length : 0);

            if (!items || !items.length) return;

            const validUpdates = [];
            const deletedIds = [];

            for (const newItem of items) {
                const tagId = String(newItem.id || newItem.entityId);
                if (!tagId || tagId === 'undefined') continue;

                if (newItem.event === 'deleted' || newItem._deleted) {
                    deletedIds.push(tagId);
                    continue;
                }

                const existingItem = state.entities[tagId] || {};

                const objItem = {
                    ...existingItem,
                    id: Number(tagId),
                    label: newItem.label !== undefined ? newItem.label : existingItem.label,
                    color: newItem.color !== undefined ? newItem.color : existingItem.color,
                    parentId: newItem.parentId !== undefined ? newItem.parentId : existingItem.parentId,
                    level: newItem.level !== undefined ? newItem.level : existingItem.level,
                    tagPath: newItem.tagPath !== undefined ? newItem.tagPath : existingItem.tagPath,
                    path: newItem.path !== undefined ? newItem.path : existingItem.path,
                    hasChildren: newItem.hasChildren !== undefined ? newItem.hasChildren : existingItem.hasChildren,
                    disabled: newItem.disabled !== undefined ? newItem.disabled : existingItem.disabled,
                    unitsCount: newItem.unitsCount !== undefined ? newItem.unitsCount : existingItem.unitsCount,
                    driversCount: newItem.driversCount !== undefined ? newItem.driversCount : existingItem.driversCount
                };

                validUpdates.push(objItem);
            }

            if (deletedIds.length > 0) {
                tagAdapter.removeMany(state, deletedIds);
            }
            if (validUpdates.length > 0) {
                tagAdapter.upsertMany(state, validUpdates);
            }
        },
        removeTags: tagAdapter.removeMany,
        clearTags: tagAdapter.removeAll,
    }
});

export const { upsertManyWithRules, removeTags, clearTags } = tagSlice.actions;

export const tagSelectors = tagAdapter.getSelectors(state => state.realtime.tag);

export default tagSlice.reducer;
